import React from 'react';
import { connect } from 'react-redux';
import ToolTip from 'react-portal-tooltip';
import Timestamp from "react-timestamp"
import moment from "moment"
import PropTypes from 'prop-types';
export class Sensor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tooltipOpen: false
		}
	}
	onMouseEnter() {
		this.setState({ tooltipOpen: true })
	}
	onMouseLeave() {
		this.setState({ tooltipOpen: false })
	}

	render() {
		let sensor = this.props.sensor;
		let parentName = null;
		if (sensor.id) {
			if (this.props.nodeMap[sensor.id] && this.props.nodeMap[sensor.id].parent) {
				parentName = this.props.nodeMap[sensor.id].parent.info.name;
			}
		}
		let style = { left: sensor.xpercent + '%', top: sensor.ypercent + '%' };
		let className = 'point';
		if (sensor.registered && (sensor.lastonl + 24 * 60 * 60 > moment().unix())) {
			if (sensor.faulty) {
				className += ' faulty';
			} else {
				if (sensor.inuse) {
					className += ' inuse';
				} else if (sensor.standby) {
					className += ' standby';
				}
			}
		} else {
			className += ` unregistered`
		}
		return (
			<React.Fragment>
				<div className={className} style={style}
					id={"sensor" + sensor.id}
					onMouseEnter={() => this.onMouseEnter()}
					onMouseLeave={() => this.onMouseLeave()}
				/>
				<ToolTip active={this.state.tooltipOpen} parent={"#sensor" + sensor.id} position="right" arrow="center"
					style={{
						style: {
							background: "rgba(0,0,0,.9)",
							padding: 10,
							color: "#EEE",
							boxShadow: "0px 4px 6px rgba(0,0,0,.3)",
							borderRadius: 4
						},
						arrowStyle: {
							color: 'rgba(0,0,0,.8)',
							borderColor: false
						}
					}}
				>
					<table><tbody><tr>
						<td>
							<div>{sensor.name}</div>
							<div>{sensor.macaddress.toUpperCase()}</div>
							<div>{parentName}</div>
							{
								(!sensor.registered) ?
									<div> Maintenance {/*Change from Unregistered to Maintenance*/} </div>
									:
									(sensor.faulty ? <div>Offline since <Timestamp time={sensor.lastonl} /></div> : "")
							}
						</td>
					</tr></tbody></table>
				</ToolTip>
			</React.Fragment>
		)
	}
}
function mapStateToProps(state) {
	return {
		nodeMap: state.overviewReducer.nodeMap
	}
}
function mapDispatchToProps(dispatch) {
	return {
		dispatch
	}
}
Sensor.propTypes = {
	nodeMap: PropTypes.object.isRequired,
	sensor: PropTypes.object.isRequired
}
export default connect(mapStateToProps, mapDispatchToProps)(Sensor);



// WEBPACK FOOTER //
// ./src/components/pages/sensorsettings/sensor.jsx